import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import Global from './common/global'

import "./common/directives/select";
import "./common/directives/datepicker";
import "./common/directives/canaccess";
import "./common/directives/htmleditor";

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

 Vue.use(BootstrapVue);
 Vue.use(BootstrapVueIcons)

import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);

import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/custom.scss";

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, {
    siteKey: Global.KEY_RECAPTCHA,
    loaderOptions: {
        useEnterprise: true
    }
})

Vue.config.productionTip = false;

Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  render: (h) => h(App),
  mounted() {
    this.$eventHub.$on("show-notification", (data) => {
      let _config = {
        position: "top",
        toast: true,
        type: data.type,
        title: data.title,
        html: data.text,
        timer: 5000,
        showConfirmButton: false,
      };

      if (data.type == "error") {
        _config.timer = null;
        _config.showCancelButton = true;
        _config.cancelButtonText = "Fechar";
      }

      if (data.modal) {
        _config.position = "center";
        _config.toast = false;
        _config.showConfirmButton = true;
        _config.showCancelButton = false;
        _config.timer = null;
        _config.allowOutsideClick = false;
        _config.allowEscapeKey = false;
        _config.allowEnterKey = false;
      }

      this.$swal(_config);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("show-notification");
  },
}).$mount("#app");
